/**
 * 汇总页交互。目录和封面由 Liquid 输出，这里只处理：
 * 目录点击滚动、滚动时的当前团、作品横滑和进度条、打开预览。
 */
;(() => {
  if (window.pqGroupHub) return

  const instances = new Map()
  const mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null

  function readConfig(root) {
    const node = root.querySelector('[data-pq-group-hub-config]')
    if (!node) return {}
    try {
      return JSON.parse(node.textContent || '{}')
    } catch (error) {
      return {}
    }
  }

  function motion() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return 'auto'
    return 'smooth'
  }

  function selectWork(detail) {
    if (detail.uuid) {
      document.dispatchEvent(new CustomEvent('pq:open-design-preview', { detail }))
      document.dispatchEvent(new CustomEvent('pq:work-selected', { detail }))
      return
    }
    const link = detail.el && detail.el.getAttribute('data-link')
    if (link) window.location.assign(link)
  }

  function mount(root) {
    if (!root || root.dataset.pqMounted === 'true') return
    root.dataset.pqMounted = 'true'

    const config = readConfig(root)
    const directory = root.querySelector('[data-pq-group-directory]')
    const panels = root.querySelector('[data-pq-group-hub-panels]')
    const anchorMode = config.directoryAction !== 'page'
    const panelNodes = panels ? panels.querySelectorAll('[data-pq-group-panel]') : []
    const directoryLinks = directory ? directory.querySelectorAll('[data-pq-group-link]') : []
    const workRows = []

    let activeFrame = 0
    let activeGroupId = ''
    let pinnedGroupId = null
    let selectionUnlock = null

    function sidePad() {
      const row = directory.querySelector('.pq-group-directory__row')
      const value = row ? parseFloat(window.getComputedStyle(row).paddingInlineStart) : 0
      return Number.isFinite(value) ? value : 0
    }

    function revealDirectoryItem(link) {
      if (!directory || !link || !directoryLinks.length) return
      const maxScroll = Math.max(0, directory.scrollWidth - directory.clientWidth)
      const lastLink = directoryLinks[directoryLinks.length - 1]
      if (link === directoryLinks[0]) {
        if (directory.scrollLeft !== 0) directory.scrollTo({ left: 0, behavior: motion() })
        return
      }
      if (link === lastLink) {
        if (Math.abs(directory.scrollLeft - maxScroll) > 1) directory.scrollTo({ left: maxScroll, behavior: motion() })
        return
      }
      const pad = sidePad()
      const box = directory.getBoundingClientRect()
      const rect = link.getBoundingClientRect()
      let delta = 0
      if (rect.left < box.left + pad) delta = rect.left - box.left - pad
      else if (rect.right > box.right - pad) delta = rect.right - box.right + pad
      else return
      const next = Math.min(maxScroll, Math.max(0, directory.scrollLeft + delta))
      directory.scrollTo({ left: next, behavior: motion() })
    }

    function unlockSelection() {
      pinnedGroupId = null
      if (!selectionUnlock) return
      window.clearTimeout(selectionUnlock.timer)
      window.removeEventListener('scrollend', selectionUnlock.onEnd)
      selectionUnlock = null
    }

    // 点击触发的平滑滚动会经过中间团体。这段时间忽略滚动高亮，避免选中态来回闪。
    function lockSelection(groupId) {
      unlockSelection()
      pinnedGroupId = groupId
      let armed = false
      const onEnd = () => {
        if (!armed) return
        unlockSelection()
      }
      selectionUnlock = { onEnd, timer: window.setTimeout(onEnd, 1200) }
      window.addEventListener('scrollend', onEnd)
      window.requestAnimationFrame(() => {
        armed = true
      })
    }

    function anchorOffset() {
      const bar = directory && directory.closest('.pq-group-directory-bar')
      if (mobileQuery && mobileQuery.matches && bar) {
        const stickyTop = parseFloat(window.getComputedStyle(bar).top) || 0
        return stickyTop + bar.offsetHeight
      }
      const header = document.querySelector('.shopify-section-header-sticky:not(.shopify-section-header-hidden)')
      return header ? header.getBoundingClientRect().height : 0
    }

    function setCurrent(groupId) {
      if (!directory || !groupId || groupId === activeGroupId) return
      if (pinnedGroupId && groupId !== pinnedGroupId) return
      activeGroupId = groupId
      let currentLink = null
      directoryLinks.forEach((link) => {
        if (link.getAttribute('data-pq-group-link') === groupId) {
          link.setAttribute('aria-current', 'true')
          currentLink = link
        } else {
          link.removeAttribute('aria-current')
        }
      })
      revealDirectoryItem(currentLink)
    }

    function updateActive() {
      if (!anchorMode || !panelNodes.length || pinnedGroupId) return
      const line = anchorOffset() + 1
      let current = panelNodes[0]
      panelNodes.forEach((panel) => {
        if (panel.getBoundingClientRect().top <= line) current = panel
      })
      setCurrent(current.getAttribute('data-pq-group-id'))
    }

    function scheduleActive() {
      if (activeFrame) return
      activeFrame = window.requestAnimationFrame(() => {
        activeFrame = 0
        updateActive()
      })
    }

    function onDirectoryClick(event) {
      const link = event.target && event.target.closest ? event.target.closest('a[href^="#"]') : null
      if (!link || !directory.contains(link)) return
      const id = decodeURIComponent(link.getAttribute('href').slice(1))
      const panel = document.getElementById(id)
      if (!panel) return
      event.preventDefault()
      const groupId = link.getAttribute('data-pq-group-link')
      const top = panel.getBoundingClientRect().top + window.pageYOffset - anchorOffset()
      lockSelection(groupId)
      activeGroupId = ''
      setCurrent(groupId)
      window.scrollTo({ top: Math.max(0, top), behavior: motion() })
    }

    function onWorkClick(event) {
      const btn = event.target && event.target.closest ? event.target.closest('[data-pq-wcl-open]') : null
      if (!btn || !panels || !panels.contains(btn)) return
      event.preventDefault()
      const panel = btn.closest('[data-pq-group-panel]')
      selectWork({
        uuid: btn.getAttribute('data-uuid') || '',
        slug: panel ? panel.getAttribute('data-pq-collection-slug') || '' : '',
        title: btn.getAttribute('data-title') || '',
        meta: btn.getAttribute('data-meta') || '',
        productHandle: btn.getAttribute('data-product-handle') || '',
        el: btn,
      })
    }

    function bindProgress(grid) {
      const panel = grid.closest('.pq-group-works')
      const bar = panel && panel.querySelector('.pq-group-works__progress')
      const fill = bar && bar.querySelector('.pq-group-works__progress-fill')
      if (!bar || !fill || grid._pqProgress) return
      let metrics = null
      function measure() {
        const styles = window.getComputedStyle(grid)
        const gapValue = parseFloat(styles.columnGap || styles.gap || '0')
        const card = grid.querySelector(':scope > .pq-work-card:not([hidden])')
        metrics = {
          sliding: styles.display === 'flex' && styles.flexWrap === 'nowrap',
          gap: Number.isNaN(gapValue) ? 0 : gapValue,
          total: grid.querySelectorAll(':scope > .pq-work-card:not([hidden])').length,
          cardWidth: card ? card.getBoundingClientRect().width : 0,
        }
      }
      function paint() {
        if (!metrics) measure()
        const maxScroll = Math.max(grid.scrollWidth - grid.clientWidth, 0)
        if (!metrics.sliding || maxScroll <= 1 || metrics.total < 1) {
          bar.hidden = true
          return
        }
        bar.hidden = false
        const perPage = window.pqPagedScroller
          ? window.pqPagedScroller.pageSize(grid.clientWidth, metrics.cardWidth, metrics.gap)
          : 1
        const start = Math.min(perPage, metrics.total) / metrics.total
        const seen = start + (1 - start) * (grid.scrollLeft / maxScroll)
        fill.style.width = `${Math.min(1, Math.max(0, seen)) * 100}%`
      }
      function onScroll() {
        paint()
      }
      function onResize() {
        metrics = null
        paint()
      }
      grid.addEventListener('scroll', onScroll, { passive: true })
      let observer = null
      if (typeof ResizeObserver !== 'undefined') {
        observer = new ResizeObserver(onResize)
        observer.observe(grid)
      } else {
        window.addEventListener('resize', onResize)
      }
      paint()
      grid._pqProgress = {
        refresh: onResize,
        destroy() {
          grid.removeEventListener('scroll', onScroll)
          if (observer) observer.disconnect()
          else window.removeEventListener('resize', onResize)
          delete grid._pqProgress
        },
      }
    }

    function mountWorksRow(grid) {
      if (!grid || !window.pqPagedScroller || grid._pqWorksRow) return grid && grid._pqWorksRow
      const row = window.pqPagedScroller.mountScreen(grid, { itemSelector: '.pq-work-card' })
      if (!row) return null
      bindProgress(grid)
      const destroyRow = row.destroy
      const measureRow = row.refresh
      row.destroy = () => {
        destroyRow()
        if (grid._pqProgress) grid._pqProgress.destroy()
        delete grid._pqWorksRow
      }
      row.refresh = () => {
        measureRow()
        if (grid._pqProgress) grid._pqProgress.refresh()
      }
      grid._pqWorksRow = row
      workRows.push(row)
      return row
    }

    if (panels) {
      panels.querySelectorAll('.pq-group-works__grid').forEach((grid) => {
        const row = mountWorksRow(grid)
        if (row) row.refresh()
      })
      panels.addEventListener('click', onWorkClick)
    }

    if (anchorMode && panelNodes.length) {
      updateActive()
      window.addEventListener('scroll', scheduleActive, { passive: true })
      window.addEventListener('resize', scheduleActive)
    }
    if (directory && anchorMode) directory.addEventListener('click', onDirectoryClick)

    function destroy() {
      unlockSelection()
      if (activeFrame) window.cancelAnimationFrame(activeFrame)
      workRows.splice(0).forEach((row) => row.destroy())
      window.removeEventListener('scroll', scheduleActive)
      window.removeEventListener('resize', scheduleActive)
      if (panels) panels.removeEventListener('click', onWorkClick)
      if (directory && anchorMode) directory.removeEventListener('click', onDirectoryClick)
      instances.delete(root.id)
      delete root.dataset.pqMounted
    }

    instances.set(root.id, destroy)
    root._pqDestroy = destroy
  }

  document.addEventListener('shopify:section:unload', (event) => {
    const sectionId = event.detail && event.detail.sectionId
    const destroy = sectionId && instances.get(`PqGroupHub-${sectionId}`)
    if (destroy) destroy()
  })

  document.addEventListener('shopify:section:load', (event) => {
    const sectionId = event.detail && event.detail.sectionId
    const root = sectionId && document.getElementById(`PqGroupHub-${sectionId}`)
    if (root) mount(root)
  })

  window.pqGroupHub = { mount }
})()
